import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SkillService {

  constructor(private http: HttpClient) { }

  getAll(): Observable<any> {
    return this.http
      .get(
        `/api/v1/skills`
      );
  }

  getById(skillId:string): Observable<any> {
    return this.http
      .get(
        `/api/v1/skills/${skillId}`
      );
  }

  getByType(type:string): Observable<any> {
    return this.http
      .get(
        `/api/v1/skills/type/${type}`
      );
  }


}



// WEBPACK FOOTER //
// ./client/app/services/skill.service.ts